import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClampComponent } from './clamp/clamp.component';
import { ObserversModule } from '@angular/cdk/observers';

@NgModule({
  imports: [CommonModule, ObserversModule],
  declarations: [ClampComponent],
  exports: [ClampComponent],
  providers: [{ provide: Window, useValue: window }],
})
export class DlsClampModule {}
